module.exports = __webpack_public_path__ + "static/media/map_icon.bf8b31fb.svg";